import { CategoryDictionary } from '../../../../types/types';

import animaux from './animaux';
import corpsEgyptien from './corps';
import couleursEgyptien from './couleur';
import lecture from './lecture';
import lectureAnalytique, {
    lectureAnalytiqueDeterminatifs,
    lectureAnalytiqueKemet,
    lectureAnalytiqueHistoire,
} from './lectureAnalytique';
import phrase, { phraseNom, phrasePronoms } from './phrase';
import famille from './famille';
import nombresEgyptien from './nombres';
import verbesEgyptien from './verbes';
import nourriture from './nourritures';
import temps from './temps';
import objets from './objets';
import divinites from './divinites';
import villes from './villes';
import pharaons from './pharaons';
import plantes from './plantes';
import monuments from './monuments';

export const categories: CategoryDictionary = {
    'Nombres': nombresEgyptien,
    'Verbes': verbesEgyptien,
    'Animaux': animaux,
    'Lire les hiéroglyphes': lecture,
    'Lecture analytique': lectureAnalytique,
    'Lecture analytique — déterminatifs': lectureAnalytiqueDeterminatifs,
    'Lecture analytique — Kemet': lectureAnalytiqueKemet,
    'Lecture analytique — histoire': lectureAnalytiqueHistoire,
    'Phrase': phrase,
    'Phrase — le nom': phraseNom,
    'Phrase — pronoms': phrasePronoms,
    'Famille': famille,
    'Corps': corpsEgyptien,
    'Couleurs': couleursEgyptien,
    'Nourriture': nourriture,
    'Temps': temps,
    'Objets sacrés et du quotidien': objets,
    'Divinités': divinites,
    'Villes': villes,
    'Pharaons': pharaons,
    'Plantes': plantes,
    'Sur les murs des temples': monuments,
};

export default categories;
